module.exports = __webpack_public_path__ + "assets/img/SpinTel-Pillar-Page-Resource-w540.e279cdf7.jpg";